import Vue from 'vue'

export const setCurrentProductImages = (state, images) => {
  state.currentProduct.images = images
}

export const setCurrentProductImagesCount = (state, count) => {
  state.currentProduct.imagesCount = count
}

export const setCurrentProductId = (state, id) => {
  state.currentProduct.id = id
}

export const setCurrentProductImageLimit = (state, value) => {
  state.currentProduct.imagesLimit = value
}

export const setProductVariants = (state, productVariants) => {
  state.productVariants = productVariants.data
}

export const setProductVariantsByIndex = (state, value) => {
  state.productVariants['data'].product_variant[value.index][value.key] = value.value
}

export const setCurrentProduct = (state, productId) => {
  state.currentProduct.id = productId
}

export const setCurrentRelatedProducts = (state, relatedProducts) => {
  state.currentProduct.relatedProducts = relatedProducts
}

export const setCurrentProductVariantImageEdit = (state, value) => {
  state.currentProduct.variantImageEdit = value
}

export const setCurrentProductVariant = (state, param) => {
  if (param.key === 'page') {
    state.currentProduct.variantSetting.page = param.value
  } else if (param.key === 'sort') {
    state.currentProduct.variantSetting.page = 1
    state.currentProduct.variantSetting.sort = param.value.sort
    state.currentProduct.variantSetting.order = param.value.order
  }
}

export const setOrderResult = (state, value) => {
  state.orders.result.list = value.orders
  state.orders.result.page_total = value.page.page_count
  state.orders.result.current_page = parseInt(value.page.number)
  state.orders.result.order_total = value.orders_count
}

export const setOrderSearch = (state, param) => {
  state.orders.search = param
}

export const setBusinessId = (state, value) => {
  state.rmp_business.business_id = value.data.data.business_id
}

export const setOrderAdvanceSearch = (state, value) => {
  if (state.orders.advanceSearch === false) {
    state.orders.advanceSearch = true
  } else {
    state.orders.advanceSearch = false
  }
}
export const setAddressToggle = (state, value) => {
  if (state.orders.addressToggle === false) {
    state.orders.addressToggle = true
  } else {
    state.orders.addressToggle = false
  }
}
export const setSearchInputClear = (state, value) => {
  state.orders.searchInputClear = value
}

export const setIsSearch = (state, param) => {
  state.orders.search.isSearch = param
}

export const setAllProductList = (state, param) => {
  state.productList = param
}

export const setAttributeObject = (state, param) => {
  state.attributes.push(param)
}

export const setUpdateAttributeObject = (state, param) => {
  state.attributes[param.key] = param.object
}

export const clearAttributeObject = (state) => {
  state.attributes = []
}

export const setattributeStateSelectObject = (state, param) => {
  if (typeof state.attributeStateSelect[param.productId] === 'undefined' || state.attributeStateSelect[param.productId] === '' || state.attributeStateSelect[param.productId] === null) {
    state.attributeStateSelect[param.productId] = {}
  }
  state.attributeStateSelect[param.productId][param.attributeId] = true
}

export const clearattributeStateSelectObject = (state) => {
  state.attributeStateSelect = {}
}

export const updateProductListByIndex = (state, param) => {
  Vue.set(state.productList[param.index], 'image_path', param.image_path)
  Vue.set(state.productList[param.index], 'normal_price', param.normal_price)
  Vue.set(state.productList[param.index], 'special_price', param.special_price)
  Vue.set(state.productList[param.index], 'sku', param.sku)
  Vue.set(state.productList[param.index], 'variants', param.variants)
  Vue.set(state.productList[param.index], 'stock', param.stock)
  Vue.set(state.productList[param.index], 'product_image', param.image_path)
  Vue.set(state.productList[param.index], 'product_price_range', param.product_price_range)
}

export const addNewProductList = (state, param) => {
  state.addNewProductList.push(state.productList[param])
}

export const removeNewProductList = (state, param) => {
  state.addNewProductList.splice(param, 1)
}
export const clearNewProductList = (state) => {
  state.addNewProductList = []
}
export const addNewProductRemoveList = (state, param) => {
  state.newProductRemoveList.push(state.addNewProductList[param])
}

export const clearNewOrderProductList = (state) => {
  state.productList = []
}

export const setGrandTotal = (state, param) => {
  Vue.set(state.orders, 'grandTotal', param)
}

export const setOrderNewProductList = (state, param) => {
  Vue.set(state.addNewProductList, param.index, param.data)
}

export const clearNewOrderData = (state) => {
  state.input.shippingAddress = {...state.input.shippingAddress, 'firstname': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'lastname': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'email': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'tel': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'address': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'address2': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'country': '1'}
  state.input.shippingAddress = {...state.input.shippingAddress, 'province': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'district': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'subDistrict': ''}
  state.input.shippingAddress = {...state.input.shippingAddress, 'postcode': ''}

  state.input.contactAddress = {...state.input.contactAddress, 'firstname': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'lastname': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'email': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'tel': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'address': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'address2': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'country': '1'}
  state.input.contactAddress = {...state.input.contactAddress, 'province': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'district': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'subDistrict': ''}
  state.input.contactAddress = {...state.input.contactAddress, 'postcode': ''}

  state = {...state, 'addNewProductList': []}
}

export const setCurrentProductVariantImages = (state, images) => {
  state.currentProductVariants.images = images
}

export const setCurrentProductVariantImagesCount = (state, count) => {
  state.currentProductVariants.imagesCount = count
}

export const setCurrentProductVariantId = (state, id) => {
  state.currentProductVariants.id = id
}

export const setCurrentProductVariantImageLimit = (state, value) => {
  state.currentProductVariants.imagesLimit = value
}

export const setDefaultOrderFrom = (state, param) => {
  Vue.set(state.input, 'orderFrom', param)
}



// WEBPACK FOOTER //
// ./src/store/mutations.js